import ImpressionAdCostReducer from 'store/impression-ad-cost/reducers';

export default ImpressionAdCostReducer;
